import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { notification } from "antd";

import { LoginForm } from "../../../components";
import { BRAND_TEXT, MESSAGE_TEXT } from "../../../constants/textConstants";
import { endpoints } from "../../../endpoints";

const toastType = {
    error: {
        icon: "ic:round-error",
        class: "text-red-600"
    },
    success: { icon: "mdi:success-circle", class: "text-green-400" }
};

const createUser = async (data: { email: string; name: string; domain: string }) => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const returnUrl = urlParams.get('returnUrl') || "";
    const invite_payload = urlParams.get('invitePayload');
    // const source = urlParams.get('source');
    const awsAccountId = urlParams.get('awsAccountId')|| ""
    const offerType = urlParams.get('offerType')|| ""
    const partner = urlParams.get('partner')|| ""
    const sugerEntitlementId = urlParams.get('sugerEntitlementId')|| ""

    const response2 = await fetch(endpoints.createUser, {
        method: "POST",
        headers: {
            Accept: "application.json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            email_id: data.email.toString().trim(),
            name: data.name.toString().trim(),
            domain: data.domain.toString().trim(),
            plan_id: localStorage.getItem("planId"),
            return_url: returnUrl,
            invite_payload: invite_payload,
            market_place_details: {
                partner: partner,
                suger_entitlement_id: sugerEntitlementId,
                aws_market_place_details: {
                    account_id: awsAccountId,
                    offer_type: offerType,
                },
            },

        })
    });
    return response2;
};

const Signup = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [domain, setDomain] = useState("");

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const invitePayload = queryParams.get('invitePayload');
        const userEmail = queryParams.get('userEmail');

        if(invitePayload && userEmail){
          setEmail(userEmail);
          setDomain(userEmail.split("@")[1] || "");
        }
    }, []);

    useEffect(() => {
        const SessionEmailId = localStorage.getItem("SessionEmailId");
        const SessionDomain = localStorage.getItem("SessionDomain")
        if (SessionEmailId !== null) {
            setEmail(SessionEmailId);
            setDomain(SessionDomain !== null ? SessionDomain : SessionEmailId.split("@")[1] || "");
            localStorage.removeItem("SessionEmailId");
            localStorage.removeItem("SessionDomain")
        }
    }, []);

    const [api, contextHolder] = notification.useNotification();
    const openNotification = (message: string, type: { icon: string; class: string }) => {
        api.success({
            icon: <Icon icon={type.icon} className={type.class} />,
            message,
            placement: "top",
            duration: 2
        });
    };
    // const { data } = useQuery("options", fetchSignupOptions);
    const [isEmailSent, setIsEmailSent] = useState(false);
    const { mutate, isLoading } = useMutation(createUser, {
        onSuccess: async (data) => {
            if (data.status === 201) {
                navigate("/on-boarding");
            }
            if (data.status === 200) {
                setIsEmailSent(true);
                return;
            }
            if (data.status === 400) {
                openNotification("there was an error", toastType.error);
            }
        },
        onError: (data) => {
            openNotification("there was an error", toastType.error);
        }
    });

    return (
        <div className="flex flex-col h-full">
            {contextHolder}
            <div className="flex flex-col w-full h-full md:flex-row">
                <div className="flex flex-col grow justify-center h-full relative">
                    <LoginForm
                        email={email}
                        mutate={mutate}
                        setEmail={setEmail}
                        isLoading={isLoading}
                        isEmailSent={isEmailSent}
                        setIsEmailSent={setIsEmailSent}
                        name={name}
                        setName={setName}
                        domain={domain}
                        setDomain={setDomain}
                    />
                </div>
            </div>
        </div>
    );
};

export default Signup;
